@charset "UTF-8";

/* src/app/components/v2-album-overlay/v2-album-overlay.component.scss */
:host {
  display: contents;
}
.v2-ao-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.v2-album-overlay:focus {
  outline: none;
}
body.v2-album-overlay-open {
  overflow: hidden;
}
.v2-album-overlay {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform-origin: 50% 50%;
  animation: v2-album-overlay-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
  --v2-ao-sk-shimmer-base: #cfd6de;
  --v2-ao-sk-shimmer-mid: #e2e8ef;
  --v2-ao-sk-shimmer-hi: #f0f4f8;
  --v2-ao-sk-card-tint: rgba(255, 255, 255, 0.78);
  --v2-ao-sk-card-border: rgba(13, 18, 24, 0.07);
  background: var(--exme-overlay-atmosphere-background);
}
body.dark .v2-album-overlay {
  --v2-ao-sk-shimmer-base: #1f2732;
  --v2-ao-sk-shimmer-mid: #2a3442;
  --v2-ao-sk-shimmer-hi: #364353;
  --v2-ao-sk-card-tint: rgba(22, 28, 36, 0.92);
  --v2-ao-sk-card-border: rgba(255, 255, 255, 0.08);
}
.v2-album-overlay.v2-album-overlay--closing {
  pointer-events: none;
  animation: v2-album-overlay-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-album-overlay-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-album-overlay-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-album-overlay {
    animation: none;
  }
  .v2-album-overlay.v2-album-overlay--closing {
    animation: none;
    opacity: 0;
  }
  .album-card-block {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
.v2-ao-first-page {
  position: absolute;
  top: 0.65rem;
  left: calc(0.65rem + env(safe-area-inset-left));
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition:
    transform 0.12s ease,
    background 0.12s ease,
    opacity 0.12s ease;
}
.v2-ao-first-page ion-icon {
  font-size: 1.35rem;
}
body.dark .v2-ao-first-page {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.92);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}
.v2-ao-first-page:active:not(:disabled) {
  transform: scale(0.88);
}
body.dark .v2-ao-first-page:active:not(:disabled) {
  background: rgba(32, 40, 52, 0.96);
}
body:not(.dark) .v2-ao-first-page:active:not(:disabled) {
  background: rgba(255, 255, 255, 0.96);
}
.v2-ao-first-page:focus-visible {
  outline: 2px solid rgba(13, 18, 24, 0.45);
  outline-offset: 2px;
}
body.dark .v2-ao-first-page:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
}
.v2-ao-first-page--hidden {
  opacity: 0;
  pointer-events: none;
}
.v2-ao-first-page:disabled {
  opacity: 0.28;
  cursor: default;
}
.v2-ao-first-page:disabled:active {
  transform: none;
}
.v2-ao-close {
  position: absolute;
  top: 0.65rem;
  right: calc(0.65rem + env(safe-area-inset-right));
  z-index: 60;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition: transform 0.12s ease, background 0.12s ease;
}
body.dark .v2-ao-close {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.92);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}
.v2-ao-close:active {
  transform: scale(0.88);
}
body.dark .v2-ao-close:active {
  background: rgba(32, 40, 52, 0.96);
}
body:not(.dark) .v2-ao-close:active {
  background: rgba(255, 255, 255, 0.96);
}
.v2-ao-close:focus-visible {
  outline: 2px solid rgba(13, 18, 24, 0.45);
  outline-offset: 2px;
}
body.dark .v2-ao-close:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
}
.v2-ao-title-pill {
  position: absolute;
  top: 1.1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 55;
  width: max-content;
  max-width: min(92vw, 22rem);
  padding: 0.42rem 0.95rem;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.35;
  color: rgba(13, 18, 24, 0.92);
  pointer-events: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.08);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
body.dark .v2-ao-title-pill {
  color: rgba(255, 255, 255, 0.94);
  background: rgba(22, 28, 36, 0.9);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
}
.v2-ao-layout-loading {
  position: absolute;
  inset: 0;
  z-index: 48;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  padding-top: 5rem;
  box-sizing: border-box;
  pointer-events: none;
}
.v2-ao-layout-loading__lottie.loader {
  width: 100px;
  height: 100px;
}
.v2-ao-layout-loading__label {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(13, 18, 24, 0.88);
}
body.dark .v2-ao-layout-loading__label {
  color: rgba(255, 255, 255, 0.9);
}
.v2-ao-body {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow-x: visible;
  overflow-y: hidden;
}
.v2-ao-body.v2-ao-body--layout-pending {
  opacity: 0;
  pointer-events: none;
}
.v2-ao-scroll-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 4.25rem;
  padding-bottom: 4.25rem;
  padding-left: max(0.5rem, env(safe-area-inset-left));
  padding-right: max(0.5rem, env(safe-area-inset-right));
  box-sizing: border-box;
}
.v2-ao-scroll-center--zoomed {
  overflow-x: visible;
  overflow-y: hidden;
  touch-action: none;
}
.v2-ao-zoom-surface {
  flex: 0 0 auto;
  width: 100%;
  transform-origin: 0 0;
  will-change: transform;
}
.v2-ao-scroll-center::before,
.v2-ao-scroll-center::after {
  content: "";
  flex: 1 1 0;
  min-height: 0;
}
.album-card-block {
  flex: 0 0 auto;
  width: 100%;
  max-width: min(94vw, 26rem);
  margin-inline: auto;
  padding: 0 0.45rem 0.25rem;
  box-sizing: border-box;
  transform-origin: center center;
  animation: v2-ao-album-card-enter 0.58s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
}
@keyframes v2-ao-album-card-enter {
  from {
    opacity: 0;
    transform: translate3d(0, min(42vh, 500px), 0) scale(0.44);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
.v2-ao-carousel-shell {
  position: relative;
  width: 100%;
}
.v2-ao-slide-skeleton {
  position: absolute;
  inset: 0;
  z-index: 25;
  pointer-events: none;
  border-radius: 14px;
  background: rgb(255, 255, 255);
  box-shadow: 0 4px 18px rgba(13, 18, 24, 0.08);
}
.v2-ao-slide-skeleton--blocking {
  pointer-events: auto;
  cursor: wait;
}
body.dark .v2-ao-slide-skeleton {
  background: rgb(22, 28, 36);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}
.v2-ao-album-skeleton-card {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 200px;
  border-radius: 12px;
  overflow: hidden;
  background: var(--v2-ao-sk-card-tint);
  box-shadow: inset 0 0 0 1px var(--v2-ao-sk-card-border), inset 0 0 48px rgba(13, 18, 24, 0.04);
}
.v2-ao-album-skeleton-card--insert {
  box-shadow: inset 0 0 0 1px var(--v2-ao-sk-card-border), inset 0 0 24px rgba(13, 18, 24, 0.03);
}
.v2-ao-album-skeleton-insert {
  position: absolute;
  inset: 0;
  border-radius: inherit;
}
.v2-ao-album-skeleton-shimmer {
  background:
    linear-gradient(
      105deg,
      var(--v2-ao-sk-shimmer-base) 0%,
      var(--v2-ao-sk-shimmer-base) 34%,
      var(--v2-ao-sk-shimmer-mid) 44%,
      var(--v2-ao-sk-shimmer-hi) 50%,
      var(--v2-ao-sk-shimmer-mid) 56%,
      var(--v2-ao-sk-shimmer-base) 66%,
      var(--v2-ao-sk-shimmer-base) 100%);
  background-size: 240% 100%;
  animation: v2-ao-album-skeleton-shimmer 1.5s ease-in-out infinite;
}
.v2-ao-album-skeleton-top {
  position: absolute;
  top: 5.5%;
  left: 4.5%;
  right: 4.5%;
  display: flex;
  align-items: center;
  gap: 3.5%;
  z-index: 1;
}
.v2-ao-album-skeleton-top .v2-ao-album-skeleton-logo:first-of-type {
  animation-delay: 0s;
}
.v2-ao-album-skeleton-top .v2-ao-album-skeleton-header.v2-ao-album-skeleton-shimmer {
  animation-delay: 0.06s;
}
.v2-ao-album-skeleton-top .v2-ao-album-skeleton-logo:last-of-type {
  animation-delay: 0.12s;
}
.v2-ao-album-skeleton-logo {
  flex: 0 0 11%;
  max-width: 2.25rem;
  min-width: 1.35rem;
  aspect-ratio: 1;
  border-radius: 50%;
}
.v2-ao-album-skeleton-header {
  flex: 1;
  min-width: 0;
  height: clamp(1.15rem, 7.5%, 1.65rem);
  border-radius: 9px;
}
.v2-ao-album-skeleton-grid {
  position: absolute;
  top: 19%;
  left: 4.5%;
  right: 4.5%;
  bottom: 14%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 3.5% 3%;
  z-index: 1;
}
.v2-ao-album-skeleton-cell {
  border-radius: 9px;
  min-height: 0;
}
.v2-ao-album-skeleton-cell:nth-child(1) {
  animation-delay: 0s;
}
.v2-ao-album-skeleton-cell:nth-child(2) {
  animation-delay: 0.09s;
}
.v2-ao-album-skeleton-cell:nth-child(3) {
  animation-delay: 0.18s;
}
.v2-ao-album-skeleton-cell:nth-child(4) {
  animation-delay: 0.27s;
}
.v2-ao-album-skeleton-cell:nth-child(5) {
  animation-delay: 0.36s;
}
.v2-ao-album-skeleton-cell:nth-child(6) {
  animation-delay: 0.45s;
}
.v2-ao-album-skeleton-footer {
  position: absolute;
  left: 12%;
  right: 12%;
  bottom: 10%;
  height: clamp(0.65rem, 3.8%, 0.95rem);
  border-radius: 6px;
  z-index: 1;
}
.v2-ao-album-skeleton-footer.v2-ao-album-skeleton-shimmer {
  animation-delay: 0.18s;
}
.v2-ao-album-skeleton-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 3.5%;
  margin: 0;
  padding: 0 0.5rem;
  text-align: center;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(13, 18, 24, 0.5);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.35);
  z-index: 2;
}
body.dark .v2-ao-album-skeleton-caption {
  color: rgba(255, 255, 255, 0.48);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}
@keyframes v2-ao-album-skeleton-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-ao-album-skeleton-shimmer {
    animation: none;
    background: var(--v2-ao-sk-shimmer-mid);
    background-size: 100% 100%;
  }
  .v2-ao-album-skeleton-cell {
    animation-delay: 0s !important;
  }
}
.v2-ao-carousel-viewport {
  position: relative;
  width: 100%;
  overflow: visible;
  touch-action: pan-y;
}
.v2-ao-carousel-track {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  will-change: transform;
  overflow: visible;
}
.v2-ao-carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  position: relative;
}
.v2-ao-carousel-slide-inner {
  width: 100%;
  transform-origin: center center;
  transition: transform 330ms ease, opacity 330ms ease;
}
.v2-ao-carousel-slide-inner--inactive {
  pointer-events: none;
}
.v2-ao-carousel-viewport.is-dragging .v2-ao-carousel-slide-inner {
  transition: none;
}
@media (prefers-reduced-motion: reduce) {
  .v2-ao-carousel-slide-inner {
    transition: none;
  }
}
.album-page {
  position: relative;
  width: 100%;
  padding-top: 141%;
  margin-bottom: 0;
  border-radius: 14px;
  overflow: hidden;
  isolation: isolate;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(13, 18, 24, 0.06);
}
body.dark .album-page {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45);
  border-color: rgba(255, 255, 255, 0.06);
}
.v2-ao-carousel-viewport.is-dragging .album-page {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
}
body.dark .v2-ao-carousel-viewport.is-dragging .album-page {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}
.scalable-container {
  position: absolute;
  top: 0;
  overflow: hidden;
  border-radius: inherit;
}
.v2-album-overlay .v2-ao-album-img {
  display: block;
  object-fit: cover;
}
.album-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform-origin: center center;
  border-radius: inherit;
}
.draggable-section {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.card-page-header {
  text-align: center;
  background: none;
  box-shadow: none;
}
.card-page-footer {
  text-align: center;
  background: none;
  box-shadow: none;
}
.card-page-left-logo,
.card-page-right-logo {
  width: 100%;
  margin-bottom: 0;
  padding-right: 5px;
  padding-top: 0;
  opacity: 1;
}
.card-col {
  text-align: center;
  padding-bottom: 2px;
}
.ldiv,
.l2div,
.pdiv {
  border: 1px solid transparent;
  display: flex;
  width: 100%;
  justify-content: center;
}
.card4l,
.card4l2,
.card4p {
  position: absolute;
  height: 90%;
  opacity: 1;
}
.transparent {
  background-color: transparent;
}
.custom-image {
  background-color: transparent;
  position: absolute;
  max-width: 90%;
  max-height: 90%;
  margin: auto;
  opacity: 1;
}
.v2-ao-album-sticker-slot {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.v2-ao-draggable-card-wrap {
  overflow: hidden;
}
.v2-ao-draggable-inserted-wrap {
  width: auto;
  height: auto;
  overflow: visible;
}
.v2-ao-draggable-inserted-img {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.v2-album-overlay .v2-ao-draggable-inserted-img {
  object-fit: contain;
}
.v2-ao-album-sticker-placeholder {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-step-150, #dfe5ec) 0%,
      var(--ion-color-step-100, #eceff2) 100%);
}
body.dark .v2-ao-album-sticker-placeholder {
  background:
    linear-gradient(
      135deg,
      #1f2835 0%,
      #2a3442 100%);
}
.v2-ao-album-sticker-slot--locked .v2-ao-album-img {
  filter: blur(2px) grayscale(100%);
  opacity: 0.88;
}
.v2-ao-album-locked-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
}
.v2-ao-album-locked-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.58);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}
.v2-ao-album-locked-icon {
  width: 22px;
  height: 22px;
  color: rgba(255, 255, 255, 0.98);
}
.v2-ao-nav-stack {
  position: absolute;
  bottom: calc(env(safe-area-inset-bottom) + 1.1rem);
  left: 50%;
  transform: translateX(-50%);
  z-index: 60;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  max-width: min(96vw, 420px);
  pointer-events: none;
}
.v2-ao-buy-peek {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 0.35rem;
  transform: translateY(calc(100% + 0.45rem + 2.9rem));
  opacity: 0;
  pointer-events: none;
  transition: transform 0.58s cubic-bezier(0.22, 1.12, 0.36, 1), opacity 0.38s ease;
}
.v2-ao-buy-peek--visible {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}
.v2-ao-buy-btn-shell {
  display: flex;
  justify-content: center;
  max-width: 100%;
  border-radius: 999px;
}
.v2-ao-buy-btn-shell--celebrate {
  position: relative;
  padding: 3px;
  border-radius: 999px;
  overflow: hidden;
  animation: v2AoBuyCelebrateShell 1.2s cubic-bezier(0.22, 1, 0.36, 1) 1 forwards;
}
.v2-ao-buy-btn-shell--celebrate::before {
  content: "";
  position: absolute;
  inset: -45%;
  z-index: 0;
  border-radius: 50%;
  background:
    conic-gradient(
      from 0deg,
      #ff006e,
      #fb5607,
      #ffbe0b,
      #06d6a0,
      #8338ec,
      #3a86ff,
      #ff006e);
  animation: v2AoBuyCelebrateRing 1.15s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1 forwards;
}
.v2-ao-buy-btn-shell--celebrate .v2-ao-buy-btn {
  position: relative;
  z-index: 1;
}
@keyframes v2AoBuyCelebrateShell {
  0%, 82% {
    padding: 3px;
  }
  100% {
    padding: 0;
  }
}
@keyframes v2AoBuyCelebrateRing {
  0% {
    transform: rotate(0deg) scale(2);
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  100% {
    transform: rotate(720deg) scale(3);
    opacity: 0;
  }
}
.v2-ao-buy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0.38rem 1rem 0.42rem;
  border: 1px solid rgba(13, 18, 24, 0.08);
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(13, 18, 24, 0.85);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s ease;
}
.v2-ao-buy-btn:active {
  transform: scale(0.97);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.v2-ao-buy-btn__icon {
  font-size: 1.05rem;
  flex-shrink: 0;
  color: currentColor;
}
.v2-ao-buy-btn__label {
  white-space: nowrap;
  max-width: min(56vw, 240px);
  overflow: hidden;
  text-overflow: ellipsis;
}
body.dark .v2-ao-buy-btn {
  color: rgba(255, 255, 255, 0.88);
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.35);
}
body.dark .v2-ao-buy-btn:active {
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.28);
}
@media (prefers-reduced-motion: reduce) {
  .v2-ao-buy-peek {
    transition: opacity 0.2s ease;
  }
  .v2-ao-buy-peek--visible {
    transform: translateY(0);
  }
  .v2-ao-buy-btn-shell--celebrate {
    padding: 0;
    animation: none;
  }
  .v2-ao-buy-btn-shell--celebrate::before {
    display: none;
  }
}
.v2-ao-nav {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.45rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 18, 24, 0.08);
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  width: 100%;
  max-width: min(96vw, 420px);
  box-sizing: border-box;
}
body.dark .v2-ao-nav {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.35);
}
.v2-ao-nav-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  color: rgba(13, 18, 24, 0.85);
  font-size: 1.15rem;
  flex-shrink: 0;
  transition: transform 0.12s ease;
}
body.dark .v2-ao-nav-arrow {
  color: rgba(255, 255, 255, 0.88);
}
.v2-ao-nav-arrow:active {
  transform: scale(0.85);
}
.v2-ao-nav-arrow--hidden {
  opacity: 0;
  pointer-events: none;
}
.v2-ao-nav-arrow:disabled {
  opacity: 0.28;
  cursor: default;
}
.v2-ao-nav-arrow:disabled:active {
  transform: none;
}
.v2-ao-nav-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.28rem;
  min-width: 0;
  flex: 1 1 auto;
  max-width: min(58vw, 300px);
}
.v2-ao-nav-count {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: rgba(13, 18, 24, 0.5);
  white-space: nowrap;
  line-height: 1;
}
body.dark .v2-ao-nav-count {
  color: rgba(255, 255, 255, 0.55);
}
.v2-ao-nav-track {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 3px 2px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.v2-ao-nav-track::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.v2-ao-nav-seg {
  flex: 0 0 7px;
  width: 7px;
  min-width: 7px;
  height: 7px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: rgba(13, 18, 24, 0.22);
  transition:
    flex 200ms cubic-bezier(0.34, 1.56, 0.64, 1),
    width 200ms cubic-bezier(0.34, 1.56, 0.64, 1),
    min-width 200ms cubic-bezier(0.34, 1.56, 0.64, 1),
    border-radius 200ms ease,
    background 200ms ease;
}
body.dark .v2-ao-nav-seg {
  background: rgba(255, 255, 255, 0.28);
}
.v2-ao-nav-seg--active {
  flex: 0 0 18px;
  width: 18px;
  min-width: 18px;
  border-radius: 999px;
  background: rgba(var(--ion-color-primary-rgb), 0.9);
}
body.dark .v2-ao-nav-seg--active {
  background: rgba(var(--ion-color-primary-rgb), 0.85);
}
@media (prefers-reduced-motion: reduce) {
  .v2-ao-nav-seg {
    transition: background 200ms ease;
  }
}
/*# sourceMappingURL=v2-album-overlay.component.css.map */
